<template>
  <div class="question-view-dialog">
    <!-- <el-button size="small" @click="showTrueFalse"> 按钮 </el-button> -->
    <div class="quest">
      <div class="title">
        <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="form.title" :safe="false"/>
      </div>
      <div class="sum-region">
        <!-- 加减乘 -->
        <div class="canvas" v-if="equation.sumType != '/'">
          <div class="num-item" v-for="(its, idx) in numList" :key="idx">
            <!-- 运算符 -->
            <span class="symbol" v-if="idx == (numList.length == 3 ? 1 : 2)">{{ symbol[equation.sumType] }}</span>

            <!-- 数字 -->
            <div class="num-block" v-for="(item, index) in its" :key="index">
              <span class="empty" v-if="item == '#'"></span>
              <span class="num" v-else-if="item.indexOf('a') == -1">{{ item }}</span>
              <div v-else class="fill">
                <input type="text" :value="item.replace('a', '')" :data-idx="`${idx}-${index}`"  id="" maxlength="1" @input="getNumList($event)">
              </div>
            </div>
          </div>
        </div>

        <!-- 除 -->
        <div class="division" v-else>
          <div class="divisor">
            <div class="num-block" v-for="(item, idx) in numList.divisor" :key="idx">
              <span class="empty" v-if="item == '#'"></span>
              <span class="num" v-else-if="item.indexOf('a') == -1">{{ item }}</span>
              <div class="fill" v-else>
                <input type="text" :value="item.replace('a', '')" :data-idx="`divisor-${idx}`" id="" maxlength="1" @input="getNumList($event)">
              </div>
            </div>
          </div>

          <div class="discuss">
            <div class="single" v-for="(its, idx) in numList.list" :key="idx">
              <!-- 样式 -->
              <div class="division-style" v-if="idx == 0"></div>
              <div class="num-block" v-for="(item, index) in its" :key="index">
                <span class="empty" v-if="item == '#'"></span>
                <span class="num" v-else-if="item.indexOf('a') == -1">{{ item }}</span>
                <div class="fill" v-else>
                  <input type="text" :value="item.replace('a', '')" :data-idx="`list-${idx}-${index}`" maxlength="1" id="" @input="getNumList($event)">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import division from './division'
import changeSunType from './handleSum'

export default {
  props: ['form', 'mode', 'recordData'],
  data() {
    return {
      mathjaxNum: 0,
      symbol: {
        '+': '➕',
        '-': '➖',
        '*': '✖️',
        '/': '➗',
      },

      image: '',
      topic: '',
      equation: {},

      /**
       * 填空列表 
       * equation.sumType != division
       * 加减乘
       * [
       *   ['2', '3', '4', '1', '2'],
       *   ['#', '2', '3', '4', '1'],
       *   ['2', '5', '7', '5', '3'], 
       * ]
       * 
       * equation.sumType == division
       * 除
       * {
       *    divisor: ['2'],
       *    list: [
       *      ['#', '6', '2'],
       *      ['1', '2', '4'],
       *      ['1', '2', '#'],
       *      ['#', '#', '4'],
       *      ['#', '#', '4'],
       *      ['#', '#', '0'],
       *    ]
       * }
       */
      // 填空列表 加减乘
      numList: [],
      // 答案列表
      correctMap: {},
      fillIdx: 0,
      randomIdx: {
        subscript: 0,
        number: 0
      },

      answer_results: {
        id: null,
        student_choices: []
      },
      // 记录题目及答案
      recordQuestion: {},
      // record: JSON.parse(localStorage.getItem('record'))
      record: JSON.parse(JSON.stringify(this.recordData))
      
    }
  },
  methods: {
    onRenderComplete(i) {
      let num = 1 

      if(i == num) {
        this.$parent.loading = false
      }
    },
    // 重置
    resetting() {
      // 数据清空
      this.$emit('permissions', false)
      
      let blocks = document.querySelectorAll('.dialog-preview .fill > input')
      for(let i = 0; i < blocks.length; i++) {
        blocks[i].value = ''
      }
    },
    showTrueFalse() {
      let data = this.recordQuestion
      , { studentAnswer, fillIdx } = data
      , correct, blocks = document.querySelectorAll('.dialog-preview .fill > input')
      this.numList = data.numList

      if(this.form.type == 8) {
        let {num1, num2, num4} = data.numberList

        if(fillIdx == 1) correct = String(num1).split(',')
        else if(fillIdx == 2) correct = String(num2).split('')
        else if(fillIdx == 3) correct = String(num4).split('')

        // 回显答案
        for(let i = 0; i < studentAnswer.length; i++) {
          blocks[i].value = studentAnswer[i]
          console.log(correct, studentAnswer)
          if(correct[i] == studentAnswer[i]) blocks[i].parentNode.classList.add('determine-success-br')
          else blocks[i].parentNode.classList.add('determine-error-br')
        }
      } else if(this.form.type == 3) {
        let { form } = this,
        answers = form.answers.map(its => its.value)

        // 回显答案
        for(let i = 0; i < studentAnswer.length; i++) {
          blocks[i].value = studentAnswer[i]
          
          if(answers[i] == studentAnswer[i]) blocks[i].parentNode.classList.add('determine-success-br')
          else blocks[i].parentNode.classList.add('determine-error-br')
        }
      }
    },
    getNumList(e) {
      let dom = e.target
      this.correctMap[dom.dataset.idx].val = dom.value
      let existEmpty = Object.values(this.correctMap).some(its => its.val != '')
  
      if(!existEmpty) this.$emit('permissions', false)
      else {
        this.$emit('permissions', true)
        console.log(Object.values(this.correctMap), this.correctMap)
        this.answer_results.student_choices = []
        this.recordQuestion.studentAnswer = Object.values(this.correctMap).map(its => its.val)
        if(this.form.type == 8) {
          let id, value = ''
          Object.values(this.correctMap).some(its => {
            id = its.id
            value += its.val
          })

          console.log(this.randomIdx)
          if(this.fill > this.randomIdx.subscript) {
            console.log(1)
            this.answer_results.student_choices.push({choice_id: Number(id), value})
            this.answer_results.student_choices.push({choice_id: 1, value: String(this.randomIdx.number)})
            this.answer_results.student_choices.push({choice_id: 2, value: String(this.randomIdx.number)})
          } else {
            console.log(2)
            this.answer_results.student_choices.push({choice_id: 0, value: String(this.randomIdx.number)})
            this.answer_results.student_choices.push({choice_id: Number(id), value})
            // this.answer_results.student_choices.push({choice_id: 2, value: })

          }

          console.log(this.answer_results)
        } else {
          Object.values(this.correctMap).some(its => {
            this.answer_results.student_choices.push({choice_id: Number(its.id), value: its.val})
          })
        }

        console.log(this.recordQuestion)
      }
    },
    /**
     * 获取变数答案
     * return [
     *  { value: ''}
     * ]
     */
    getVariate() {
      let { numberList, fillIdx } = this.recordQuestion,
      answer, result = []

      switch(fillIdx) {
        case 1: 
          answer = numberList.num1
          break;
        case 2: 
          answer = numberList.num2
          break;
        case 3: 
          if(numberList.num3) {
            answer = numberList.num3
          } else {
            answer = numberList.num4
          }
          break;
        case 4: 
          answer = numberList.num4
          break;
      }

      result = String(answer).split('').map( i => ({value: i}))
      return result
    },
    // 处理加减乘 数据
    handleSum(numList) {
      let numListCopy = [],
      correctMapCopy = {},
      { choices, type} = this.form,
      ids = choices.map(its => its.id),
      idKey = '',
      answers
      // 还原答案
      if(type == 3) {
        answers = JSON.parse(JSON.stringify(this.form.answers))
      } else {
        answers = this.getVariate()
      }
      console.log(JSON.stringify(this.recordQuestion, false, 2))
      // 处理列式数据
      numList.filter((its, idx) => {
        numListCopy[idx] = []

        its.filter((item, index) => {
          if(item.check){ 
            numListCopy[idx][index] = this.answersAddString(answers ? answers[0].value : '')
            answers && answers.splice(0, 1)
            if(type == 8) idKey = ids[0]
            else idKey = ids.splice(0, 1)[0]
            console.log(idKey)
            correctMapCopy[`${idx}-${index}`] = {
              id: idKey,
              val: ''
            }
          }
          else numListCopy[idx][index] = item.num
        })
      })

      this.numList = numListCopy
      this.correctMap = correctMapCopy
      this.recordQuestion.numList = this.numList
    },
    answersAddString(answer) {
      return 'a' + answer
    },
    // 处理除 数据
    handleDivision({divisor, list}) {
      let numListCopy = {divisor: [], list: []},
      correctMapCopy = {},
      { choices } = this.form,
      // 还原答案
      answers = JSON.parse(JSON.stringify(this.form.answers)),
      ids = choices.map(its => its.id),
      idKey = ''

      // 处理列式数据
      divisor.filter((item, idx) => {
        if(item.check){ 
          idKey = ids.splice(0, 1)[0]
          numListCopy.divisor.push(this.answersAddString(answers[0].value))
          answers.splice(0, 1)
          correctMapCopy[`divisor-${idx}`] = {
            id: idKey,
            val: ''
          }
        }
        else numListCopy.divisor.push(item.num)
      })

      list.filter((its, idx) => {
        numListCopy.list[idx] = []

        its.filter((item, index) => {
          if(item.check) { 
            idKey = ids.splice(0, 1)[0]
            numListCopy.list[idx][index] = this.answersAddString(answers[0].value)
            answers.splice(0, 1)
            correctMapCopy[`list-${idx}-${index}`] = {
              id: idKey,
              val: ''
            }
          }
          else numListCopy.list[idx][index] = item.num
        })
      })

      this.numList = numListCopy
      this.correctMap = correctMapCopy
      this.recordQuestion.numList = this.numList
    },
    handleEquation(equation, letter) {
      console.log(equation)
      // let {third_input, operator} = equation
      // , randomNum, num1, num2, num3, num4
      let {first_input, second_input, third_input, result, operator} = equation
      , randomNum, num1, num2, num3, num4
      first_input
      if(first_input.type == 0) {
        let [s, e] = first_input.range.split(',')
        , end = Math.max(s, e)
        , start = Math.min(s, e)
        num1 = Math.floor(Math.random() * (end - start + 1)) + start * 1
        this.randomIdx = {
          subscript: 1,
          number: num1
        }
        this.recordQuestion.randomIdx = 1
      } else if(first_input.type == 2) {
        randomNum = 1
        this.fillIdx = 1
        this.recordQuestion.fillIdx = 1
      } else num1 = first_input.value

      // second_input
      if(second_input.type == 0) {
        let [s, e] = second_input.range.split(',')
        , end = Math.max(s, e)
        , start = Math.min(s, e)
        num2 = Math.floor(Math.random() * (end - start + 1)) + start * 1
        this.randomIdx = {
          subscript: 2,
          number: num2
        }
        this.recordQuestion.randomIdx = 2
      } else if(second_input.type == 2) {
        randomNum = 2
        this.fillIdx = 2
        this.recordQuestion.fillIdx = 2
      } else num2 = second_input.value

      // third_input
      if(third_input != undefined && third_input.type == 0) {
        let [s, e] = third_input.range.split(',')
        , end = Math.max(s, e)
        , start = Math.min(s, e)
        num3 = Math.floor(Math.random() * (end - start + 1)) + start * 1
        this.randomIdx = {
          subscript: 3,
          number: num3
        }
        this.recordQuestion.randomIdx = 3
      } else if(third_input != undefined && third_input.type == 2) {
        randomNum = 3
        this.fillIdx = 3
        this.recordQuestion.fillIdx = 3
      } else if(third_input != undefined) num3 = third_input.value

      // result
      if(result.type == 0) {
        let [s, e] = result.range.split(',')
        , end = Math.max(s, e)
        , start = Math.min(s, e)
        num4 = Math.floor(Math.random() * (end - start + 1)) + start * 1
        this.randomIdx = {
          subscript: third_input != undefined ? 4 : 3,
          number: num4
        }
        this.recordQuestion.randomIdx = third_input != undefined ? 4 : 3
      } else if(result.type == 2) {
        randomNum = third_input != undefined ? 4 : 3
        this.fillIdx = third_input != undefined ? 4 : 3
        this.recordQuestion.fillIdx = third_input != undefined ? 4 : 3
      } else num4 = result.value

      // 截胡上面的程序 重置数据
      let {numberList} = this.record
      num1 = numberList.num1
      num2 = numberList.num2
      num3 = numberList.num3
      num4 = numberList.num4
      
      // if(fillIdx == 1) {
      //   // num1 = 12
      //   num2 = numberList.num2
      //   if(numList.length == 3) {
      //     num4 = numberList.num4
      //   } else {
      //     num4 = numberList.num4
      //   }
      // }
      
      // num3 = 

      console.log(num1, num2, num3)
      if(randomNum == 1) {
        switch(operator) {
          case '+' : num1 = num4 - num2 - (num3 || 0) ;break
          case '-' : num1 = Number(num2) + Number(num4) + Number(num3 || 0) ;break
          case '*' : num1 = num4 / num2 / (num3 || 1);break
          case '/' : num1 = num4 * num2 ;break
        }
        console.log(num1, 'num1')
        num1 != Math.floor(num1) && this.handleEquation(equation, letter)
      } else if(randomNum == 2) {
        switch(operator) {
          case '+' : num2 = num4 - num1 - (num3 || 0) ;break
          case '-' : num2 = Number(num1) - Number(num4) - Number(num3 || 0) ;break
          case '*' : num2 = num4 / num1 / (num3 || 1) ;break
          case '/' : num2 = num4 * num1 ;break
        }
        console.log(num2, 'num2')
        num2 != Math.floor(num2) && this.handleEquation(equation, letter)
      } else if(randomNum == 3) {
        if(third_input != undefined ) {
          // 目前只处理 加法
          switch(operator) {
            case '+' : num3 = num4 - Number(num1) - Number(num2) ;break
            case '-' : num3 = num1 - num2 - num4;break
            case '*' : num3 = num4 / num1 / num2;break
            case '/' : num3 = num1 / num2 ;break
          }
          console.log(num3, 'num3')
          num3 != Math.floor(num3) && this.handleEquation(equation, letter)
        } else {
          switch(operator) {
            case '+' : num4 = Number(num1) + Number(num2) + Number(num3 || 0);break
            case '-' : num4 = num1 - num2 - Number(num3 || 0) ;break
            case '*' : num4 = num1 * num2 * (num3 || 1);break
            case '/' : num4 = num1 / num2 ;break
          }
          console.log(num4, 'num4')
          num4 != Math.floor(num4) && this.handleEquation(equation, letter)
        }
        
      } else if(randomNum == 4) {
        switch(operator) {
          case '+' : num4 = Number(num1) + Number(num2) + Number(num3 || 0);break
          case '-' : num4 = num1 - num2 - Number(num3 || 0) ;break
          case '*' : num4 = num1 * num2 * Number(num3 || 0) ;break
          case '/' : num4 = num1 / num2 ;break
        }
        console.log(num4, 'num5', operator)
        // num4 != Math.floor(num4) && this.handleEquation(equation, letter)
      }
      this.recordQuestion.numberList = {num1, num2, num4}

      if(third_input != undefined)
        this.recordQuestion.numberList.num3 = num3

      switch(randomNum) {
        case 1:  
          num1 = String(num1).split('').map(() => {
            return letter.splice(0, 1)[0]
          }).join('')
          break
        case 2:  
          num2 = String(num2).split('').map(() => {
            return letter.splice(0, 1)[0]
          }).join('')
          break
        case 3:  
        console.log('third_input', third_input)
          if(third_input != undefined) {
            num3 = String(num3).split('').map(() => {
              return letter.splice(0, 1)[0]
            }).join('')
          } else {
            num4 = String(num4).split('').map(() => {
              return letter.splice(0, 1)[0]
            }).join('')
          }
          break
        case 4:  
          num4 = String(num4).split('').map(() => {
            return letter.splice(0, 1)[0]
          }).join('')
          break
      }

      let resultData = {num1, num2, num4, sumType: operator}
      if(third_input != undefined) {
        resultData.num3 = num3
      }
      console.log('resultData')
      console.log(resultData)
      return resultData
    },
    initData() {
      this.equation = {}
      // 填空列表 加减乘
      this.numList = []
      // 答案列表
      this.correctMap = {}
      this.fillIdx = 0
      this.randomIdx = {
        subscript: 0,
        number: 0
      }
      this.answer_results = {
        id: null,
        student_choices: []
      },
      // 记录题目及答案
      this.recordQuestion = {}

      let regex = /\(\)/g,
      letter = new Array(62).fill().map((its, idx) => its = String.fromCharCode(65 + idx)),
      tempSum = {},
      fillDom = document.querySelectorAll('.dialog-preview .fill > input')

      // 清空输入的数字
      for(let i = 0; i < fillDom.length; i++) {
        fillDom[i].value = ''
      }
      
      let content = JSON.parse(this.form.content.split('-------')[0]),
      answers = JSON.parse(JSON.stringify(this.form.answers)),
      copyCte = {
        num1: content.first_input,
        num2: content.second_input,
        num4: content.result,
        sumType: content.operator
      }
      console.log(this.form)
      if(content.third_input != undefined) {
        copyCte.num3 = content.third_input
      }

      if(this.form.type == 3) {
        let num1 = content.first_input.match(regex)
        let num2 = content.second_input.match(regex)
        let num3
        let num4 = content.result.match(regex)
        
        num2 != null && num2.filter(its => {
          // 区分除法与 加减乘
          if(copyCte.sumType == '/') {
            copyCte.num2 = copyCte.num2.replace(its, `(${answers[0].value})`)
          } else {
            copyCte.num2 = copyCte.num2.replace(its, letter[0])
            tempSum[letter[0]] = answers[0].value
            letter.splice(0, 1)
          }
          answers.splice(0, 1)
        })
    
        if(content.third_input != undefined) {
          num3 = content.third_input.match(regex)
          num3 != null && num3.filter(its => {
            // 区分除法与 加减乘
            if(copyCte.sumType == '/') {
              copyCte.num3 = copyCte.num3.replace(its, `(${answers[0].value})`)
            } else {
              copyCte.num3 = copyCte.num3.replace(its, letter[0])
              tempSum[letter[0]] = answers[0].value
              letter.splice(0, 1)
            }
            answers.splice(0, 1)
          })
        }

        num4 != null && num4.filter(its => {
          // 区分除法与 加减乘
          if(copyCte.sumType == '/') {
            copyCte.num4 = copyCte.num4.replace(its, `(${answers[0].value})`)
          } else {
            copyCte.num4 = copyCte.num4.replace(its, letter[0])
            tempSum[letter[0]] = answers[0].value
            letter.splice(0, 1)
          }
          answers.splice(0, 1)
        })

        num1 && num1.filter(its => {
          // 区分除法与 加减乘
          if(copyCte.sumType == '/') {
            copyCte.num1 = copyCte.num1.replace(its, `(${answers[0].value})`)
          } else {
            copyCte.num1 = copyCte.num1.replace(its, letter[0])
            tempSum[letter[0]] = answers[0].value
            letter.splice(0, 1)
          }
          answers.splice(0, 1)
        })
      } else if(this.form.type == 8) {
        console.log('-------------------')
        copyCte = this.handleEquation(content, letter)
      }
      console.log(copyCte)
      let numList = changeSunType(copyCte)
      this.equation = {...copyCte}

      if(copyCte.sumType == '/') this.handleDivision(numList)
      else this.handleSum(numList)
      if(this.mode == 'viewAnswer') setTimeout(() => this.showTrueFalse(), 500)
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.$nextTick(() => {
      // 还原答案
      let singles = document.querySelectorAll('.dialog-preview .fill')
      for(let i = 0; i < singles.length; i++) {
        singles[i].classList.add('determine-success-br')
      }
    })
  }
}
</script>

<style scoped lang="scss">
.question-view-dialog {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px; 
  
  .quest {
    width: 100%;
    height: 100%;

    .title {
      font-size: 18px;
      color: #333;
    }

    .sum-region {
      margin-top: 20px;
      $block: 40px;
      $size: 18px;
      $margin: 5px;

      .num, .empty {
        width: $block;
        height: $block;
        box-sizing: border-box;
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: $margin;
        font-size: $size;
      }
      .fill {
        width: $block;
        height: $block;
        box-sizing: border-box;
        border-radius: 3px;
        
        font-size: $size;
        margin-left: $margin;

        & > input {
          width: 100%;
          height: 100%;
          border-radius: 3px;
          background-color: #fcd2ab;
          outline: none;
          border: none;
          padding: 0;
          text-align: center;
        }
      }
      .canvas {
        padding: 10px;
        box-sizing: border-box;
        
        .num-item {
          width: fit-content;
          padding-left: $block;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-bottom: $margin;

          .symbol {
            width: $block;
            height: $block;
            box-sizing: border-box;
            border-radius: 3px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: $margin;
            font-size: $size;
          }

          .num:hover {
            // background-color: #fcd2ab;
          }
        }
        .num-item:nth-last-of-type(2) {
          margin-bottom: 10px;
          position: relative;

          &:before {
            content: '';
            position: absolute;
            width: 102%;
            height: 1px;
            background-color: #333;
            bottom: -5px;
            left: 0;
          }

          .symbol {
            position: absolute;
            border: none;
            left: 0;
            top: 0;
            margin: 0;
            cursor: default;
          }
        }
      }
      .division {
        display: flex;
        align-content: flex-start;
        margin-top: 20px;
        .divisor {
          width: fit-content;
          height: 2 * $block;
          display: flex;
          align-items: flex-end;
          margin-right: 20px;
          margin-top: $margin;
        }
        .discuss {
          width: fit-content;
          .single {
            width: fit-content;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: $margin;
          }
          .single:nth-of-type(2n - 1) {
            position: relative;
            
            &:before {
              content: '';
              position: absolute;
              bottom: calc($margin / -2);
              left: 0;
              width: 100%;
              height: 1px;
              background-color: #333;
            }
          }

          .division-style {
            position: absolute;
            width: 20px;
            height: 50px;
            top: calc(100% + $margin / 2);
            left: -20px;
            overflow: hidden;

            &:before {
              content: '';
              position: absolute;
              border-radius: 50%;
              box-sizing: border-box;
              top: -80px;
              left: -60px;
              width: 80px;
              height: 160px;
              border: 1px solid #333;
              border: none;
              border-right: 1px solid #333;
              border-bottom: 1px solid #333;
            }
          }
        }
      }
    }
  }

}
</style>